import { STM } from '../context/types';
export const be_nlStatements : STM[]  = [
    {
        id: 1,
        "valueKey": "samen1",
        title: 'werk je vaak samen',
        title_360_leadership: 'stimuleert teamwerk',
        title_360_workenv: 'werkt men vaak samen',
        preferredType: 'leadership'
    },
    {
        id: 2,
        "valueKey": "samen2",
        title: 'is de groep belangrijker dan het individu',
        title_360_leadership: 'stelt het succes van het team boven eigen succes',
        title_360_workenv: 'is de groep belangrijker dan het individu',
        preferredType: 'workenv'
    },
    {
        id: 3,
        "valueKey": "samen3",
        title: 'doe je je best voor je team',
        title_360_leadership: 'zet zich in voor zijn/haar team',
        title_360_workenv: ' doet men zijn/haar opperste best voor zijn/haar team',
        preferredType: 'leadership'
    },
    {
        id: 4,
        "valueKey": "conf1",
        title: 'geef je je mening niet als dit tot een conflict kan leiden',
        title_360_leadership: 'geeft zijn/haar mening niet als dit tot een conflict zou komen',
        title_360_workenv: 'uit je je mening niet als dat tot conflicten kan leiden',
        preferredType: 'workenv'
    },
    {
        id: 5,
        "valueKey": "conf2",
        title: 'doe je er alles aan om ruzie te voorkomen',
        title_360_leadership: 'doet er alles aan om ruzie te vermijden',
        title_360_workenv: 'doet men er alles aan om ruzie te voorkomen ',
        preferredType: 'leadership'
    },
    {
        id: 6,
        "valueKey": "conf3",
        title: 'hou je je aan de regels en normen',
        title_360_leadership: 'zorgt ervoor dat men zich houdt aan de heersende normen',
        title_360_workenv: 'respecteren we regels en normen',
        preferredType: 'workenv'
    },
    {
        id: 7,
        "valueKey": "erken1",
        title: "krijg je respect van collega's en leidinggevenden",
        title_360_leadership: "zorgt voor een omgeving waarin mensen elkaar met respect behandelen",
        title_360_workenv: "tonen collega's respect voor elkaar en voor superieuren",
        preferredType: 'workenv'
    },
    {
        id: 8,
        "valueKey": "erken2",
        title: 'krijg je erkenning voor wat je doet',
        title_360_leadership: 'geeft erkenning voor wat men doet',
        title_360_workenv: 'krijgen we erkenning voor wat we doen',
        preferredType: 'workenv'
    },
    {
        id: 9,
        "valueKey": "erken3",
        title: 'wordt inzet gewaardeerd',
        title_360_leadership: 'waardeert de geleverde inspanning',
        title_360_workenv: 'wordt inzet gewaardeerd',
        preferredType: 'leadership'
    },
    {
        id: 10,
        "valueKey": "zorg1",
        title: 'doe je goed voor anderen',
        title_360_leadership: 'is zorgzaam en respectvol',
        title_360_workenv: 'is men zorgzaam en respectvol',
        preferredType: 'leadership'
    },
    {
        id: 11,
        "valueKey": "zorg2",
        title: 'zorg je ervoor dat anderen zich goed voelen',
        title_360_leadership: 'stimuleert een sfeer waarin iedereen zich goed voelt',
        title_360_workenv: 'zorgen we ervoor dat iedereen zich goed voelt',
        preferredType: 'workenv'
    },
    {
        id: 12,
        "valueKey": "zorg3",
        title: "help je collega's, klanten en/of andere partijen",
        title_360_leadership: 'zorgt voor een klimaat van wederzijdse ondersteuning',
        title_360_workenv: "helpt men collega's, klanten en/of andere partijen",
        preferredType: 'leadership'
    },
    {
        id: 13,
        "valueKey": "gelijk1",
        title: 'krijgt iedereen gelijke kansen',
        title_360_leadership: 'behandelt iedereen gelijk en eerlijk',
        title_360_workenv: 'krijgt iedereen gelijke kansen',
        preferredType: 'workenv'
    },
    {
        id: 14,
        "valueKey": "gelijk2",
        title: 'maakt het niet uit welke je leeftijd, afkomst, of geslacht is',
        title_360_leadership: 'ziet je niet anders vanwege je leeftijd, afkomst, of geslacht',
        title_360_workenv: 'maken leeftijd, afkomst en geslacht geen verschil',
        preferredType: 'workenv'
    },
    {
        id: 15,
        "valueKey": "gelijk3",
        title: 'kijkt men naar wat je doet, niet naar wie je bent',
        title_360_leadership: 'beoordeelt ons op basis van onze acties',
        title_360_workenv: 'kijkt men naar wat je doet, niet naar wie je bent',
        preferredType: 'leadership'
    },
    {
        id: 16,
        "valueKey": "zelfsturing1",
        title: 'kan je in grote mate zelf bepalen wat je doet',
        title_360_leadership: 'zorgt ervoor dat mensen zelf in grote mate bepalen wat ze doen',
        title_360_workenv: 'kan iedereen voor het grootste deel zelf beslissen wat te doen',
        preferredType: 'workenv'
    },
    {
        id: 17,
        "valueKey": "zelfsturing2",
        title: 'bepaal je zelf je manier van werken',
        title_360_leadership: 'laat ons onze eigen manier van werken bepalen',
        title_360_workenv: 'heeft men de mogelijkheid zijn/haar manier van werken te bepalen',
        preferredType: 'leadership'
    },
    {
        id: 18,
        "valueKey": "zelfsturing3",
        title: 'plan je zelf je taken',
        title_360_leadership: 'laat ieder van ons grotendeels zelf bepalen wanneer we doen wat gedaan moet worden',
        title_360_workenv: 'kan iedereen zijn eigen taken plannen',
        preferredType: 'workenv'
    },
    {
        id: 19,
        "valueKey": "macht1",
        title: 'kan ik invloed uitoefenen op het gedrag van anderen',
        title_360_leadership: 'beïnvloedt mijn werk',
        preferredType: 'leadership'
    },
    {
        id: 20,
        "valueKey": "macht2",
        title: 'ben ik degene die zegt wat er moet gebeuren',
        title_360_leadership: 'zegt wat er moet gebeuren',
        preferredType: 'leadership'
    },
    {
        id: 21,
        "valueKey": "macht3",
        title: 'bepaal ik wat er gebeurt',
        title_360_leadership: 'is degene die zegt wat er moet gebeuren',
        title_360_workenv: 'bepalen we wat er moet gebeuren',
        preferredType: 'disabled'
    },
    {
        id: 22,
        "valueKey": "voorspelbaar1",
        title: 'is er structuur en regelmaat',
        title_360_leadership: 'zorgt voor structuur en regelmaat',
        title_360_workenv: 'is er structuur en regelmaat',
        preferredType: 'workenv'
    },
    {
        id: 23,
        "valueKey": "voorspelbaar2",
        title: 'lopen de dingen meestal zoals gepland',
        title_360_leadership: 'zorgt ervoor dat alles meestal volgens plan verloopt',
        title_360_workenv: 'lopen de dingen meestal zoals gepland',
        preferredType: 'leadership'
    },
    {
        id: 24,
        "valueKey": "voorspelbaar3",
        title: 'kan je traditionele waarden en denkpatronen behouden',
        title_360_leadership: 'waarborgt respect voor traditionele waarden en denkpatronen',
        title_360_workenv: 'behouden we traditionele waarden en denkwijzen',
        preferredType: 'workenv'
    },
    {
        id: 25,
        "valueKey": "prestatie1",
        title: 'kan je tonen hoe goed je bent',
        title_360_leadership: 'moedigt ons aan het beste van onszelf te geven',
        title_360_workenv: 'heeft men de mogelijkheid te laten zien wat zijn/haar mogelijkheden zijn',
        preferredType: 'leadership'
    },
    {
        id: 26,
        "valueKey": "prestatie2",
        title: 'kan je laten zien wat je mogelijkheden zijn',
        title_360_leadership: 'moedigt aan om zijn/haar potentieel te tonen',
        title_360_workenv: 'kun je je potentieel aantonen',
        preferredType: 'workenv'
    },
    {
        id: 27,
        "valueKey": "prestatie3",
        title: 'kan je uitblinken in wat je doet',
        title_360_leadership: 'moedigt aan om uit te blinken in wat men doet',
        title_360_workenv: 'kun je uitblinken in wat je doet',
        preferredType: 'workenv'
    },
    {
        id: 28,
        "valueKey": "zelfontplooi1",
        title: 'kan je steeds nieuwe dingen leren',
        title_360_leadership: 'moedigt aan permanente opleiding',
        title_360_workenv: 'kunnen we voortdurend leren',
        preferredType: 'workenv'
    },
    {
        id: 29,
        "valueKey": "zelfontplooi2",
        title: 'kan je je kennis verdiepen',
        title_360_leadership: 'moedigt ons aan om onze vaardigheden te ontwikkelen',
        title_360_workenv: 'heeft men de mogelijkheid zijn/haar kennis te verdiepen',
        preferredType: 'leadership'
    },
    {
        id: 30,
        "valueKey": "zelfontplooi3",
        title: 'kan je jezelf steeds blijven ontwikkelen',
        title_360_leadership: 'helpt anderen om zichzelf continu te blijven ontwikkelen',
        title_360_workenv: 'kunnen we voortdurend ontwikkelen',
        preferredType: 'workenv'
    },
    {
        id: 31,
        "valueKey": "duurzaam1",
        title: 'lever je kwaliteitsvol werk',
        title_360_leadership: 'zorgt ervoor dat het team werk van hoge kwaliteit levert',
        title_360_workenv: 'levert men kwaliteitsvol werk',
        preferredType: 'leadership'
    },
    {
        id: 32,
        "valueKey": "duurzaam2",
        title: 'heb je respect voor klanten en andere partijen',
        title_360_leadership: 'moedigt het team actief aan om respect te hebben voor klanten en andere belanghebbenden',
        title_360_workenv: 'respecteren we klanten en andere belanghebbenden',
        preferredType: 'workenv'
    },
    {
        id: 33,
        "valueKey": "duurzaam3",
        title: 'heb je aandacht voor mens, veiligheid en milieu',
        title_360_leadership: 'zorgt ervoor dat men aandacht voor mens, veiligheid en milieu heeft',
        title_360_workenv: 'zorgt men voor mens, de veiligheid en het milieu',
        preferredType: 'workenv'
    },
    {
        id: 34,
        "valueKey": "integriteit1",
        title: 'neem je verantwoordelijkheid voor wat je doet',
        title_360_leadership: 'zorgt ervoor dat men de verantwoordelijkheid neemt voor wat men doet',
        title_360_workenv: 'nemen we verantwoordelijkheid voor wat we doen',
        preferredType: 'workenv'
    },
    {
        id: 35,
        "valueKey": "integriteit2",
        title: 'is men eerlijk',
        title_360_leadership: 'is eerlijk',
        title_360_workenv: 'is men eerlijk',
        preferredType: 'workenv'
    },
    {
        id: 36,
        "valueKey": "integriteit3",
        title: 'ga je voorzichtig om met vertrouwelijke informatie',
        title_360_leadership: 'zorgvuldig omgaat met persoonlijke en vertrouwelijke informatie',
        title_360_workenv: 'gaat men voorzichtig om met persoonlijke informatie',
        preferredType: 'leadership'
    },
    {
        id: 37,
        "valueKey": "innovatie1",
        title: 'kan je nieuwe dingen uitproberen',
        title_360_leadership: 'moedigt ons aan om nieuwe manieren van werken uit te proberen',
        title_360_workenv: 'heeft men de mogelijkheid nieuwe dingen uit te proberen',
        preferredType: 'leadership'
    },
    {
        id: 38,
        "valueKey": "innovatie2",
        title: 'kan je veel nieuwe ervaringen opdoen',
        title_360_leadership: 'moedigt aan om nieuwe ervaringen op te doen',
        title_360_workenv: 'kan je nieuwe ervaring opdoen',
        preferredType: 'workenv'
    },
    {
        id: 39,
        "valueKey": "innovatie3",
        title: 'kan je uitdagingen opzoeken',
        title_360_leadership: 'stimuleert ons om nieuwe uitdagingen op te zoeken',
        title_360_workenv: 'heeft men de mogelijkheid uitdagingen op te zoeken',
        preferredType: 'leadership'
    },
    {
        id: 40,
        "valueKey": "daadkracht1",
        title: 'pak je uit eigen beweging werk op',
        title_360_leadership: 'moedigt aan om uit eigen beweging werkzaamheden op te pakken',
        title_360_workenv: 'ga je op eigen initiatief aan de slag',
        preferredType: 'workenv'
    },
    {
        id: 41,
        "valueKey": "daadkracht2",
        title: 'zorg je dat er resultaten geboekt worden',
        title_360_leadership: 'zorgt ervoor dat resultaten worden behaald',
        title_360_workenv: 'zorgt men ervoor dat er resultaten worden geboekt',
        preferredType: 'leadership'
    },
    {
        id: 42,
        "valueKey": "daadkracht3",
        title: 'doe je er alles aan om de doelen te halen',
        title_360_leadership: 'doet al het mogelijke om zijn/haar doelstellingen te bereiken',
        title_360_workenv: 'doet men er alles aan om de doelen te halen',
        preferredType: 'leadership'
    },
]
export const extra360Be_NlStatements : Omit<STM, 'title'>[] = [
    // Additional statements used in Actual360 but not IdealClassic
    {
      id: 43,
      valueKey: 'daadkracht4',
      title_360_leadership:
          'neemt beslissingen',
      preferredType: 'leadership',
    },
    {
      id: 44,
      valueKey: 'gelijk4',
      title_360_leadership:
          'respecteert en waardeert de verschillen tussen teamleden',
      preferredType: 'leadership',
    },
    {
      id: 45,
      valueKey: 'prestatie4',
      title_360_leadership:
          'geeft constructieve feedback',
      preferredType: 'leadership',
    },
]

